import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';

import homeImg1 from '../../assets/img/menu/home-1.jpg';
import homeImg2 from '../../assets/img/menu/home-2.jpg';
import homeImg3 from '../../assets/img/menu/home-3.jpg';
import homeImg4 from '../../assets/img/menu/home-4.jpg';
import homeImg5 from '../../assets/img/menu/home-5.jpg';
import homeImg6 from '../../assets/img/menu/home-6.jpg';

const MenuItems = (props) => {
  const { isMobileMenu } = props;
  const [home, setHome] = useState(false);
  const [service, setService] = useState(false);
  const [page, setPage] = useState(false);
  const [shop, setShop] = useState(false);
  const [blog, setBlog] = useState(false);

  const openMobileMenu = (menu) => {
    if (menu === 'home') {
      setHome(!home);
      setService(false);
      setPage(false);
      setShop(false);
      setBlog(false);
    } else if (menu === 'service') {
      setHome(false);
      setService(!service);
      setPage(false);
      setShop(false);
      setBlog(false);
    } else if (menu === 'page') {
      setHome(false);
      setService(false);
      setPage(!page);
      setShop(false);
      setBlog(false);
    } else if (menu === 'shop') {
      setHome(false);
      setService(false);
      setPage(false);
      setShop(!shop);
      setBlog(false);
    } else if (menu === 'blog') {
      setHome(false);
      setService(false);
      setPage(false);
      setShop(false);
      setBlog(!blog);
    }
  };

  const handleClick = (e) => {
    if (isMobileMenu === true) {
      e.preventDefault();
    }
  };

  return (
    <ul>
      {/* <li className="has-dropdown p-static">
        <Link
          to="/home-5"
          className={`${home ? 'expanded' : ''}`}
          onClick={handleClick}
        >
          Home
          <button
            className={`${
              home
                ? 'dropdown-toggle-btn dropdown-opened'
                : 'dropdown-toggle-btn'
            } d-xl-none `}
            onClick={() => {
              openMobileMenu('home');
            }}
          >
            <i className="fal fa-angle-right"></i>
          </button>
        </Link>
        <div
          className={
            home
              ? 'it-submenu submenu has-home-img d-block'
              : 'it-submenu submenu has-home-img'
          }
        >
          <div className="row gx-6 row-cols-1 row-cols-md-2 row-cols-lg-2 row-cols-xl-6">
            <div className="col home-img">
              <div className="home-img-thumb mb-15">
                <img src={homeImg1} alt="" />
                <div className="home-img-btn">
                  <Link className="it-btn-sm" to="/">
                    <Button btnText="Multi Page" />
                  </Link>
                  <Link className="it-btn-sm" to="/home-one-page">
                    <Button btnText="One Page" />
                  </Link>
                </div>
              </div>
              <div className="home-img-content text-center">
                <h4 className="home-img-title">
                  <Link to="/">Home 01</Link>
                </h4>
              </div>
            </div>
            <div className="col home-img">
              <div className="home-img-thumb mb-15">
                <img src={homeImg2} alt="" />
                <div className="home-img-btn">
                  <Link className="it-btn-sm" to="/home-2">
                    <Button btnText="Multi Page" />
                  </Link>
                  <Link className="it-btn-sm" to="/home-2-one-page">
                    <Button btnText="One Page" />
                  </Link>
                </div>
              </div>
              <div className="home-img-content text-center">
                <h4 className="home-img-title">
                  <Link to="/home-2">Home 02</Link>
                </h4>
              </div>
            </div>
            <div className="col home-img">
              <div className="home-img-thumb mb-15">
                <img src={homeImg3} alt="" />
                <div className="home-img-btn">
                  <Link className="it-btn-sm" to="/home-3">
                    <Button btnText="Multi Page" />
                  </Link>
                  <Link className="it-btn-sm" to="/home-3-one-page">
                    <Button btnText="One Page" />
                  </Link>
                </div>
              </div>
              <div className="home-img-content text-center">
                <h4 className="home-img-title">
                  <Link to="/home-3">Home 03</Link>
                </h4>
              </div>
            </div>
            <div className="col home-img">
              <div className="home-img-thumb mb-15">
                <img src={homeImg4} alt="" />
                <div className="home-img-btn">
                  <Link className="it-btn-sm" to="/home-4">
                    <Button btnText="Multi Page" />
                  </Link>
                  <Link className="it-btn-sm" to="/home-4-one-page">
                    <Button btnText="One Page" />
                  </Link>
                </div>
              </div>
              <div className="home-img-content text-center">
                <h4 className="home-img-title">
                  <Link to="/home-4">Home 04</Link>
                </h4>
              </div>
            </div>
            <div className="col home-img">
              <div className="home-img-thumb mb-15">
                <img src={homeImg5} alt="" />
                <div className="home-img-btn">
                  <Link className="it-btn-sm" to="/home-5">
                    <Button btnText="Multi Page" />
                  </Link>
                  <Link className="it-btn-sm" to="/home-5-one-page">
                    <Button btnText="One Page" />
                  </Link>
                </div>
              </div>
              <div className="home-img-content text-center">
                <h4 className="home-img-title">
                  <Link to="/home-5">Home 05</Link>
                </h4>
              </div>
            </div>
            <div className="col home-img">
              <div className="home-img-thumb mb-15">
                <img src={homeImg6} alt="" />
                <div className="home-img-btn">
                  <Link className="it-btn-sm" to="/home-6">
                    <Button btnText="Multi Page" />
                  </Link>
                  <Link className="it-btn-sm" to="/home-6-one-page">
                    <Button btnText="One Page" />
                  </Link>
                </div>
              </div>
              <div className="home-img-content text-center">
                <h4 className="home-img-title">
                  <Link to="/home-6">Home 06</Link>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </li> */}
      <li>
        <Link to="/">Home</Link>
      </li>
      <li>
        <Link to="/about-us">About us</Link>
      </li>
      <li>
        <Link to="/service">Services</Link>
      </li>
      {/* <li className="has-dropdown">
        <Link
          to="/service"
          className={service ? 'expanded' : ''}
          onClick={handleClick}
        >
          Services
          <button
            className={`${
              service
                ? 'dropdown-toggle-btn dropdown-opened'
                : 'dropdown-toggle-btn'
            } d-xl-none `}
            onClick={() => {
              openMobileMenu('service');
            }}
          >
            <i className="fal fa-angle-right"></i>
          </button>
        </Link>
        <ul
          className={
            service ? 'it-submenu submenu d-block' : 'it-submenu submenu'
          }
        >
          <li>
            <Link to="/service">Services</Link>
          </li>
          <li>
            <Link to="/service-details">Services Details</Link>
          </li>
        </ul>
      </li> */}
      
      {/* <li className="has-dropdown">
        <Link
          to="/shop-sidebar"
          className={shop ? 'expanded' : ''}
          onClick={handleClick}
        >
          Shop
          <button
            className={`${
              shop
                ? 'dropdown-toggle-btn dropdown-opened'
                : 'dropdown-toggle-btn'
            } d-xl-none `}
            onClick={() => {
              openMobileMenu('shop');
            }}
          >
            <i className="fal fa-angle-right"></i>
          </button>
        </Link>
        <ul
          className={shop ? 'it-submenu submenu d-block' : 'it-submenu submenu'}
        >
          <li>
            <Link to="/shop-column-3">Shop Column 03</Link>
          </li>
          <li>
            <Link to="/shop-column-4">Shop Column 04</Link>
          </li>
          <li>
            <Link to="/shop-sidebar">Shop Sidebar</Link>
          </li>
          <li>
            <Link to="/wishlist">Wishlist</Link>
          </li>
          <li>
            <Link to="/compare">Compare</Link>
          </li>

          <li>
            <Link to="/cart">Cart</Link>
          </li>
          <li>
            <Link to="/checkout">Checkout</Link>
          </li>
          <li>
            <Link to="/login">Login</Link>
          </li>
          <li>
            <Link to="/register">Register</Link>
          </li>
        </ul>
      </li> */}
      {/* <li className="has-dropdown">
        <Link
          to="/blog"
          className={blog ? 'expanded' : ''}
          onClick={handleClick}
        >
          Blog
          <button
            className={`${
              blog
                ? 'dropdown-toggle-btn dropdown-opened'
                : 'dropdown-toggle-btn'
            } d-xl-none `}
            onClick={() => {
              openMobileMenu('blog');
            }}
          >
            <i className="fal fa-angle-right"></i>
          </button>
        </Link>
        <ul
          className={blog ? 'it-submenu submenu d-block' : 'it-submenu submenu'}
        >
          <li>
            <Link to="/blog">Blog</Link>
          </li>
          <li>
            <Link to="/blog-sidebar">Blog Sidebar</Link>
          </li>
          <li>
            <Link to="/blog-details">Blog Details</Link>
          </li>
        </ul>
      </li> */}
      <li>
        <Link to="/complain">Complain</Link>
      </li>
      <li>
        <Link to="/contact">Contact Us</Link>
      </li>
      <li>
        <Link to="/medical">Medical Education</Link>
      </li>
      <li>
        <Link to="/edportal">ED Portal</Link>
      </li>
      <li className="has-dropdown">
        <Link to="#" className={page ? 'expanded' : ''} onClick={handleClick}>
          Others
          <button
            className={`${
              page
                ? 'dropdown-toggle-btn dropdown-opened'
                : 'dropdown-toggle-btn'
            } d-xl-none `}
            onClick={() => {
              openMobileMenu('page');
            }}
          >
            <i className="fal fa-angle-right"></i>
          </button>
        </Link>
        <ul
          className={page ? 'it-submenu submenu d-block' : 'it-submenu submenu'}
        >
          {/* <li>
            <Link to="/portfolio">portfolio</Link>
          </li>
          <li>
            <Link to="/portfolio-details">portfolio Details</Link>
          </li>
          <li>
            <Link to="/team">Team</Link>
          </li>
          <li>
            <Link to="/team-details">Team Details</Link>
          </li> */}
          <li>
            <Link to="/skill-lab">Skill Lab</Link>
          </li>
          <li>
            <Link to="/infection-prevention">Infection Prevention & Control Workshop</Link>
          </li>
          <li>
            <Link to="/media">Media</Link>
          </li>
          <li>
            <Link to="/certificates">Our Certifications</Link>
          </li>
          <li>
            <Link to="/medical/fellowship-program">Fellowship Programs</Link>
          </li>
          <li>
            <Link to="/medical/house-job">House Job / Internship Program</Link>
          </li>
          {/* <li>
            <Link to="/medical">Medical Education</Link>
          </li> */}
          <li>
            <Link to="/tenders">Tenders</Link>
          </li>
          <li>
            <Link to="/donateblood">Blood Donation</Link>
          </li>
          <li>
            <Link to="/team">Our Doctors</Link>
          </li>
          <li>
            <Link to="/event">Events</Link>
          </li>
          <li>
            <Link to="/archive">Archive</Link>
          </li>
          <li>
            <Link to="/gallery">Gallery</Link>
          </li>
          {/* <li>
            <Link to="/price">Price</Link>
          </li> */}
          {/* <li>
            <Link to="/appointment">Appointment</Link>
          </li> */}
          <li>
            <Link to="/appointments">Get Appointment</Link>
          </li>
          <li>
            <Link to="/privacy-policy">Privacy Policies</Link>
          </li>
          {/* <li>
            <Link to="/page-views">Views</Link>
          </li> */}
        </ul>
      </li>
      {/* <li>
        <Link to="/custom-contact">Tester</Link>
      </li>
      <li>
        <Link to="/custom-appointment">Add On</Link>
      </li> */}
    </ul>
  );
};

export default MenuItems;
